import { Button, Input } from '@aqarmap/aqarmap-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Modal from '~/components/Modal';
import { useFullRoutes } from '~/hooks';
import { formatNumber } from '~/lib';
import { useAppDispatch } from '~/redux/hooks';
import { closeModal } from '~/redux/features/uiState/uiStateSlice';

export default function TopupModal() {
  const { t } = useTranslation('app');
  const { MY_ACCOUNT_URL } = useFullRoutes();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [balance, setBalance] = useState<string>('');
  const numericBalance = balance === '' ? null : Number(balance);
  const formattedBalance = balance === '' ? '' : formatNumber(balance);

  const onSubmit = async () => {
    if (numericBalance) {
      await dispatch(closeModal('topUpModal'));
      navigate(MY_ACCOUNT_URL.WALLET.TOPUP(numericBalance));
    }
  };

  return (
    <Modal
      modalKey="topUpModal"
      title={t('addBalance')}
      Footer={
        <Button
          variant="primary"
          size="medium"
          className="w-full"
          onClick={onSubmit}
          disabled={numericBalance === null || numericBalance <= 0}
        >
          {t('add')}
        </Button>
      }
    >
      <div className="flex flex-col gap-1.5x w-full">
        <Input
          field={{
            name: 'balance',
            placeholder: t('balanceValue'),
            type: 'text',
            onChange: (e) => {
              const nextValue = e.target.value.replace(/,/g, '');
              if (/^\d*$/.test(nextValue)) {
                setBalance(nextValue);
              }
            },
            value: formattedBalance,
          }}
        />
      </div>
    </Modal>
  );
}
